import React from 'react';
import HistoryTable from './HistoryTable';

const SendHistory = ({ userID, collectionName, isAdminView = false }) => {
  const columns = [
    { key: 'date', label: 'Date & Time' },
    { key: 'amount', label: 'Amount' },
    { key: 'receiverId', label: 'To (Receiver ID)' },
  ];

  if (isAdminView) {
    return (
      <HistoryTable
        isTopLevelCollection={true}
        collectionName="admin_send_logs"
        title="Admin Coin Send History"
        columns={[
          { key: 'date', label: 'Date & Time' },
          { key: 'amount', label: 'Amount' },
          { key: 'receiverNumericId', label: 'Receiver ID' },
          { key: 'adminUid', label: 'Sent By (Admin UID)' }
        ]}
        searchField="receiverNumericId"
        searchFieldLabel="Receiver ID"
      />
    );
  }

  return (
    <HistoryTable
      userID={userID}
      collectionName={collectionName}
      historyType="sendHistory"
      title="Send History"
      columns={columns}
      searchField="receiverId"
      searchFieldLabel="Receiver ID"
    />
  );
};

export default SendHistory;